import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

const Modal = ({ isOpen, onClose, title, children, footer, maxWidthClass = 'max-w-lg' }) => {
    // Ensure we only attempt to access document.body on the client side
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    if (!isOpen || !isMounted) return null;

    const modalContent = (
        // Bumped z-index to 99999 to guarantee it sits above absolutely everything
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-[99999]">
            {/* The main modal content container with dark mode classes */}
            <div className={`bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full relative flex flex-col max-h-[90vh] z-[100000] ${maxWidthClass}`}>
                {/* Modal Header with dark mode classes */}
                <div className="flex justify-between items-center px-6 pt-6 pb-3 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
                    <h3 className="text-xl font-semibold text-gray-900 dark:text-white">{title}</h3>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 focus:outline-none"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"></path></svg>
                    </button>
                </div>

                {/* Modal Body - Inherits dark background. Content inside already has dark mode styles. */}
                <div className="flex-grow overflow-y-auto px-6 py-4 custom-scrollbar">
                    {children}
                </div>

                {/* Modal Footer with dark mode classes */}
                {footer && (
                    <div className="relative z-10 flex justify-end space-x-2 px-6 py-4 border-t border-gray-200 dark:border-gray-700 flex-shrink-0">
                        {footer}
                    </div>
                )}
            </div>
        </div>
    );

    // Teleport the modal directly to the body tag
    return ReactDOM.createPortal(modalContent, document.body);
};

export default Modal;